// extracted by mini-css-extract-plugin
export default {"tagSelector":"scenario-tags_tagSelector__GZKzb"};